import dayjs from "dayjs";

export const getNextRemindDate = (type, fromDate) => {
  if (!dayjs.isDayjs(fromDate) || !fromDate.isValid()) return null;

  const base = fromDate.startOf('day');

  switch (type) {
    case 'As scheduled':
    case '1 hour before': // день события; сдвиг на час — в resolveRemindDateTime
      return base;
    case '1 day before':
      return base.subtract(1, 'day');
    case '1 week before':
      return base.subtract(1, 'week');
    default:
      return null;
  }
};